import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

// Get the target language from various sources
const getInitialLanguage = () => {
  // Check URL parameter first
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');
  if (urlLang) {
    console.log('Language from URL:', urlLang);
    return urlLang;
  }

  // Check localStorage
  const storedLang = localStorage.getItem('i18nextLng');
  if (storedLang) {
    console.log('Language from localStorage:', storedLang);
    return storedLang;
  }

  // Default to English
  console.log('Language defaulting to: en');
  return 'en';
};

const initialLanguage = getInitialLanguage();
console.log('=== INITIALIZING i18n ===');
console.log('Initial language detected:', initialLanguage);

// Initialize i18next instance
// CRITICAL: Removed LanguageDetector to prevent it from overriding our explicit lng setting
i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: initialLanguage, // CRITICAL: Force initial language
    fallbackLng: 'en', // Keep fallback for when translations are missing
    supportedLngs: ['en', 'zh', 'ko', 'ja', 'id', 'th'],
    nonExplicitSupportedLngs: false,
    debug: true,
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
      // CRITICAL: Add request options to ensure translations load
      requestOptions: {
        mode: 'cors',
        credentials: 'same-origin',
        cache: 'default',
      },
    },
    react: {
      useSuspense: false, // CRITICAL: Changed to false to prevent race conditions
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
    },
    load: 'languageOnly',
    cleanCode: true,
    // CRITICAL: Preload the initial language to ensure it's loaded before rendering
    preload: [initialLanguage],
  })
  .then(() => {
    console.log('=== i18n INITIALIZED ===');
    console.log('Current language:', i18n.language);
    console.log('Resolved language:', i18n.resolvedLanguage);
    console.log('Has translation namespace:', i18n.hasLoadedNamespace('translation'));

    // Force change language to ensure it loads
    return i18n.changeLanguage(initialLanguage);
  })
  .then(() => {
    console.log('=== LANGUAGE FORCED ===');
    console.log('Final language:', i18n.language);
    console.log('Final resolved language:', i18n.resolvedLanguage);
  });

// Force reload resources when language changes
i18n.on('languageChanged', (lng) => {
  console.log('Language changed to:', lng);
  // Reload the page title
  if (i18n.exists('meta.title')) {
    document.title = i18n.t('meta.title');
  }
});

// Log when resources are loaded
i18n.on('loaded', (loaded) => {
  console.log('i18next resources loaded:', loaded);
});

// Log errors
i18n.on('failedLoading', (lng, ns, msg) => {
  console.error('i18next failed loading:', lng, ns, msg);
});

export default i18n;